import React from 'react';
import { IonPage, IonHeader, IonToolbar, IonTitle } from '@ionic/react';

import InventoryContainer from '../Containers/InventoryContainer';
import FloatingActionButton from '../components/FloatingActionButton';

const Tab2: React.FC = () => {
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar color="dark">
          <IonTitle>Inventory</IonTitle>
        </IonToolbar>
      </IonHeader>
      <InventoryContainer />
      <FloatingActionButton children="/addItem" />
    </IonPage>
  );
};

export default Tab2;
